import { render, staticRenderFns } from "./alert-setting.vue?vue&type=template&id=324373c2"
import script from "./alert-setting.vue?vue&type=script&lang=js"
export * from "./alert-setting.vue?vue&type=script&lang=js"
import style0 from "./alert-setting.vue?vue&type=style&index=0&id=324373c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports